import { render, staticRenderFns } from "./ChatBotPreview.vue?vue&type=template&id=42720df0&scoped=true&"
import script from "./ChatBotPreview.vue?vue&type=script&lang=js&"
export * from "./ChatBotPreview.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotPreview.vue?vue&type=style&index=0&id=42720df0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42720df0",
  null
  
)

export default component.exports